import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./Splash.css";
import Logo from "../../assets/logos/LogoColurs.png";
import { AuthContext } from '../../context/AuthContext';
import { GLOBAL_LANGUAGE } from "../../language/language";
import { UtilContext } from "../../context/UtilContext";

export const Splash = () => {
    const location = useLocation();
    const { companyName, activityFinal, ServiceColursFinal } = location.state || {};
    const [progress, setProgress] = useState(0);
    const [level, setLevel] = useState(null);
    const [DetailUser, setDetailUser] = useState(null);
    const { language } = useContext(UtilContext); // Usa el contexto de Auth

    const navigate = useNavigate();
    const { getAuthenticatedHeaders } = useContext(AuthContext);

    const animateProgress = (target) => {
        if (progress < target) {
            setProgress((prev) => Math.min(prev + 1, target));
            setTimeout(() => requestAnimationFrame(() => animateProgress(target)), 20);
        }
    };
    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                // Inicia la barra de progreso


                // Llama al servicio con los headers autenticados
                const response = await axios.post(`/api/user`, {
                    headers: await getAuthenticatedHeaders(),
                });


                setDetailUser(response.data.data)
                // Si la respuesta es exitosa, completa el progreso
                animateProgress(100);
                setLevel(1)

                // Redirige al dashboard después de que el progreso llegue al 100%


            } catch (error) {

            }
        };

        fetchUserDetails();

        return () => setProgress(0);
    }, [navigate]);

    useEffect(() => {
        if (progress == 100) {

            navigate("/documentacion-legal", { state: { DetailUser: DetailUser, companyName: companyName, activityFinal: activityFinal, ServiceColursFinal: ServiceColursFinal } });


        }
    }, [progress])
    useEffect(() => {
        const DetailUser = JSON.parse(localStorage.getItem('userDetails'));

        if (DetailUser.document_status === "APPROVED") {
            navigate("/splash", { state: { DetailUser: DetailUser } })
        }


    }, [])
    return (
        <div
            className="splash-overlay flex flex-col h-screen items-center justify-center"
            style={{ background: '#1a1b22' }}
        >
            <img src={Logo} style={{ width: 64, height: 64, marginBottom: 40 }} alt="Logo" />
            <p className="mb-8" style={{ color: '#8a8a8e' }}>{GLOBAL_LANGUAGE[language].splash_doc.title}</p>
            <div className="progress-container">
                <div className="progress-bar" style={{ width: `${progress}%` }}></div>
            </div>
        </div>
    );
};

export default Splash;
